import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Flex,
  Text,
  Heading,
  Spinner,
  Icon,
  useColorModeValue,
  SimpleGrid,
} from "@chakra-ui/react";
import { FaBriefcase, FaBell, FaUsers } from "react-icons/fa";
import { MdAssignment } from "react-icons/md";
import axios from "axios";
import * as mod from "../../url";
import Sidebar from "../Sidebar";
import Navbar from "../Navbar/Navbar";

const SIDEBAR_WIDTH = "250px";

const FrontPage = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const boxBg = useColorModeValue("white", "gray.800");
  const navigate = useNavigate();
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const [jobsRes, applicationsRes, usersRes, adminsRes] =
          await Promise.all([
            axios.get(`${mod.api_url}/api/v1/superAdmin/getAll-JobCount`),
            axios.get(`${mod.api_url}/api/v1/superAdmin/getAll-application`),
            axios.get(`${mod.api_url}/api/v1/superAdmin/getAll-userCount`),
            axios.get(`${mod.api_url}/api/v1/superAdmin/getAll-AdminCount`),
          ]);

        setDashboardData({
          jobCount: jobsRes.data.data,
          applicationCount: applicationsRes.data.data,
          userCount: usersRes.data.data,
          adminCount: adminsRes.data.data,
        });
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  const stats = [
    {
      label: "Jobs",
      icon: FaBriefcase,
      bg: "linear(to-r, red.200, purple.500)",
      data: dashboardData?.jobCount,
      fields: [
        { key: "totalJobs", label: "Total" },
        { key: "totalActiveJobs", label: "Active" },
        { key: "totalInactiveJobs", label: "Inactive" },
      ],
      url: "/all-Jobs",
    },
    {
      label: "Applications",
      icon: MdAssignment,
      bg: "linear(to-r, yellow.400, teal.400)",
      data: dashboardData?.applicationCount,
      fields: [
        { key: "totalApplicants", label: "Total" },
        { key: "totalAppliedApplicants", label: "Not View" },
        { key: "totalViewedApplicants", label: "Viewed" },
        { key: "totalPendingApplicants", label: "Pending" },
        { key: "totalShortlistedApplicants", label: "Shortlisted" },
        { key: "totalRejectedApplicants", label: "Rejected" },
      ],
      url: "/all-Jobs",
    },
    {
      label: "Users",
      icon: FaUsers,
      bg: "linear(to-r, orange.400, red.400)",
      data: dashboardData?.userCount,
      fields: [
        { key: "totalUsers", label: "Total" },
        { key: "totalverifyUsers", label: "Verified" },
        { key: "totalUnverifyUsers", label: "Unverified" },
      ],
      url: "/all-Jobs",
    },
    {
      label: "Admins",
      icon: FaBell,
      bg: "linear(to-r, purple.400, pink.400)",
      data: dashboardData?.adminCount,
      fields: [
        { key: "totalAdmins", label: "Total" },
        { key: "totalActiveAdmins", label: "Active" },
        { key: "totalInactiveAdmins", label: "Inactive" },
      ],
      url: "/all-Jobs",
    },
  ];

  return (
    <>
      <Navbar />
      <Sidebar />
      <Box mt="70px" ml={{ base: 0, md: SIDEBAR_WIDTH }} p={6}>
        <Heading fontSize="2xl" mb={2}>
          SUPER ADMIN DASHBOARD
        </Heading>
        <Text color="gray.500" mb={8}>
          Overview and Statistics
        </Text>

        {loading ? (
          <Flex justify="center" align="center" minH="200px">
            <Spinner size="xl" />
          </Flex>
        ) : (
          <Flex direction="column" gap={6}>
            {stats.map((stat, index) => (
              <Box
                key={index}
                bgGradient={stat.bg}
                color="white"
                p={6}
                borderRadius="lg"
                boxShadow="xl"
              >
                {/* Header with icon + label */}
                <Flex
                  align="center"
                  mb={4}
                  gap={3}
                  onClick={() => navigate(stat.url)} // ✅ navigate on click
                  cursor="pointer"
                >
                  <Icon as={stat.icon} boxSize={6} />
                  <Text fontSize="xl" fontWeight="bold">
                    {stat.label}
                  </Text>
                </Flex>

                {/* Column items inside one row */}
                <SimpleGrid
                  columns={{ base: 1, sm: 2, md: stat.fields.length }}
                  spacing={4}
                >
                  {stat.fields.map((field) => (
                    <Box
                      key={field.key}
                      bg="whiteAlpha.300"
                      p={4}
                      borderRadius="md"
                      textAlign="center"
                    >
                      <Text fontSize="md">{field.label}</Text>
                      <Text fontSize="2xl" fontWeight="bold">
                        {stat.data?.[field.key] ?? 0}
                      </Text>
                    </Box>
                  ))}
                </SimpleGrid>
              </Box>
            ))}
          </Flex>
        )}
      </Box>
    </>
  );
};

export default FrontPage;
